<template>
  <div id="top-menu" class="row">
    <div class="col-6 logo-col">
      <div class="logo text-left" @click="goToHome">
        <img src="/static/images/logo_white.svg" alt /> motivac.io
      </div>
    </div>
    <div class="col-6 logout-col">
      <font-awesome-icon :icon="'power-off'" class="logout-button" @click="logOutClicked" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TopMenu',
  methods: {
    ...mapActions({
      logOut: 'users/logOut',
    }),
    goToHome() {
      window.location.href = '/';
    },
    logOutClicked() {
      this.logOut().then(() => {
        // window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#top-menu {
  margin: 0;
  padding: 0;
  padding: 0 20px;
  height: 60px;
  width: 100%;
  background-color: $primary-color;
  .logo-col {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .logo {
    color: white;
    img {
      max-height: 30px;
    }
  }
  .logout-col {
    display: flex;
    align-items: center;
    height: 100%;
    color: white;
    justify-content: flex-end;
  }
}
</style>
